export function getError(error) {
    var _a, _b;
    if (!error) {
        return {
            reason: 'An unknown error occurred',
            message: 'An unknown error occurred'
        };
    }
    if (isEventError(error)) {
        return error;
    }
    if (isAxiosError(error)) {
        const data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        const httpResponseCode = (_b = error.response) === null || _b === void 0 ? void 0 : _b.status;
        if (isDasError(data)) {
            return transformDasError(data, httpResponseCode);
        }
        if (isApiError(data)) {
            return transformApiError(data, httpResponseCode);
        }
        return {
            reason: 'XHR_REQUEST_FAILED',
            httpResponseCode,
            message: `[StarkRequestError]: Request failed with status ${httpResponseCode}`
        };
    }
    const message = error.message
        ? `[StarkGenericError]: ${error.message}`
        : error;
    return {
        reason: message,
        message
    };
}
export function transformApiError(error, httpResponseCode) {
    var _a, _b, _c;
    const axiosMessage = `Request failed with status ${httpResponseCode}`;
    const starkRequestError = getStarkRequestError(error, httpResponseCode);
    return {
        reason: error.reason || ((_b = (_a = error.details) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.reason),
        message: starkRequestError || error.message || axiosMessage,
        errorDetails: (_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c[0],
        httpResponseCode
    };
}
export function transformDasError(error, httpResponseCode) {
    var _a, _b;
    const errorData = (_b = (_a = error === null || error === void 0 ? void 0 : error.Errors) === null || _a === void 0 ? void 0 : _a.Error) === null || _b === void 0 ? void 0 : _b[0];
    const starkRequestError = getStarkRequestError(error, httpResponseCode);
    return {
        reason: errorData === null || errorData === void 0 ? void 0 : errorData.ReasonCode,
        message: starkRequestError || errorData.Description,
        httpResponseCode,
        errorDetails: {
            status: (httpResponseCode || 0).toString(),
            reason: errorData.ReasonCode,
            source: errorData.Source,
            message: errorData.Details
        }
    };
}
export function formatError(error) {
    var _a, _b, _c;
    if (!error)
        return {};
    return {
        errorData: Object.assign({ 'http-response-code': error.httpResponseCode, reason: error.reason, message: error.message }, (error.errorDetails && {
            errorDetails: {
                reason: (_a = error.errorDetails) === null || _a === void 0 ? void 0 : _a.reason,
                message: (_b = error.errorDetails) === null || _b === void 0 ? void 0 : _b.message,
                source: (_c = error.errorDetails) === null || _c === void 0 ? void 0 : _c.source
            }
        }))
    };
}
export function getHeaders(payload) {
    return {
        'x-src-trace-id': payload.traceId,
        'correlation-id': payload.srcCorrelationId,
        'program-id': payload.serviceId
    };
}
function isEventError(error) {
    return !!error.reason && !!error.message;
}
function isAxiosError(error) {
    return error === null || error === void 0 ? void 0 : error.isAxiosError;
}
function isApiError(error) {
    return !!(error === null || error === void 0 ? void 0 : error.code);
}
function isDasError(error) {
    return !!(error === null || error === void 0 ? void 0 : error.Errors);
}
function getStarkRequestError(data, httpResponseCode) {
    if (httpResponseCode && httpResponseCode < 500) {
        return `[StarkRequestError]: ${httpResponseCode} ${JSON.stringify(data)}`;
    }
}
